import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { screenSizeMediaQuery } from './constants';
/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(refs, callback) {
    if (!Array.isArray(refs))
        refs = [refs];
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickAnywhere = (event) => {
            let clickIsInsideARef = false;
            for (const ref of refs) {
                if (!ref.current)
                    continue;
                if (ref.current.contains(event.target)) {
                    clickIsInsideARef = true;
                }
            }
            return clickIsInsideARef ? undefined : callback();
        };
        // Bind the event listener
        document.addEventListener('mousedown', handleClickAnywhere);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickAnywhere);
        };
    }, [refs, callback]);
}
export function useMounted() {
    const isMounted = useRef(false);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    return isMounted.current;
}
export function useMobile() {
    return useMediaQuery(screenSizeMediaQuery.mobile);
}
//# sourceMappingURL=hooks.js.map